import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { apiWrapper } from "../../../api/apiWrapper";
import { IBaseResponeModel } from '../../../models/response/base-response';
import { IHocSinhAceChitiet } from '../../../models/response/hoc-sinh/IHocSinhAceChitiet';
import { eHocSinhAceChiTietActionTypeIds, IHocSinhAceChiTietActionTypes } from '../../action-types/hoc-sinh/IHocSinhAceChiTietActionTypes';
import { actions } from '../../actions/actionsWrapper';
import { IHocSinhAceChiTietLoadStart } from '../../../models/request/hoc-sinh/IHocSinhAceChiTietLoadStart';
import { IHocSinhAceChiTietSubmit } from '../../../models/request/hoc-sinh/IHocSinhAceChiTietSubmit';


export function* hocSinhAceChiTietSaga(): any {
    yield takeLatest(eHocSinhAceChiTietActionTypeIds.LOAD_START, loadWorker)
    yield takeEvery(eHocSinhAceChiTietActionTypeIds.SAVE_START, saveWorker)
    yield takeEvery(eHocSinhAceChiTietActionTypeIds.DELETE_START, deleteWorker)


}

function* loadWorker(action: IHocSinhAceChiTietActionTypes): any {
    const payload: IHocSinhAceChiTietLoadStart = action.payload as IHocSinhAceChiTietLoadStart;

    const res: IBaseResponeModel = yield call(apiWrapper.hocSinhAceChiTiet.select_all_by_hocsinh, payload)
    if (res.is_success) {
        yield put(actions.hocSinhAceChiTiet.LOAD_SUCCESS(res.data))
    } else {
        yield put(actions.hocSinhAceChiTiet.LOAD_ERROR(res.message ?? "Error"))
    }
}

function* saveWorker(action: IHocSinhAceChiTietActionTypes): any {
    debugger
    const payload: IHocSinhAceChiTietSubmit = action.payload as IHocSinhAceChiTietSubmit;
    let res: IBaseResponeModel;
    if (payload.ts_hocsinh_ace_chitiet.id > 0) {
        res = yield call(apiWrapper.hocSinhAceChiTiet.update, payload.ts_hocsinh_ace_chitiet)
    } else {
        res = yield call(apiWrapper.hocSinhAceChiTiet.insert, payload)
    }
    if (res.is_success) {
        yield put(actions.hocSinhAceChiTiet.SAVE_SUCESS(res.data))
    } else {
        yield put(actions.hocSinhAceChiTiet.SAVE_ERROR(res.message ?? "Error"))
    }
}

function* deleteWorker(action: IHocSinhAceChiTietActionTypes): any {
    const payload: number = action.payload as number;
    const res: IBaseResponeModel = yield call(apiWrapper.hocSinhAceChiTiet.delete, payload)
    if (res.is_success) {
        yield put(actions.hocSinhAceChiTiet.DELETE_SUCESS(undefined))
    } else {
        yield put(actions.hocSinhAceChiTiet.DELETE_ERROR(res.message ?? "Error"))
    }
}
